import { useMutation, useQuery } from '@tanstack/react-query';
import { postUnsubscribe, type EmailLinkError, type UnsubscribeAction } from '../api/emailApi';

/**
 * Действие по ссылке из письма — POST после загрузки страницы: сканеры ссылок в почте JS не
 * выполняют и отписку не нажмут. Query, а не мутация: StrictMode и повторный рендер не шлют
 * второй POST, перезапросов по фокусу и сети нет.
 */
export function useEmailLinkQuery(token: string | null, action: UnsubscribeAction) {
  return useQuery<{ status: string }, EmailLinkError>({
    queryKey: ['email-link', action, token],
    queryFn: () => postUnsubscribe(token as string, action),
    enabled: !!token,
    retry: false,
    staleTime: Infinity,
    gcTime: 0,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
}

/** Кнопки «Вернуть напоминания» / «Отписаться» на той же странице. */
export function useEmailSubscriptionMutation(token: string | null) {
  return useMutation<{ status: string }, EmailLinkError, UnsubscribeAction>({
    mutationFn: (action) => postUnsubscribe(token as string, action),
  });
}
